import React, { FC } from 'react';
import { CopyIcon, CopyIconProps } from '@raisin/components-lib';
import { checkAllItemsHasIcon } from './utils';
import { parseToCopyIconItem } from './utils/parseToCopyIconItem';

const CopyWithIcons: FC<CopyIconProps> = (props) => {
  const { title, uid } = props;
  const allItemsHasIcon = checkAllItemsHasIcon(props.items);
  const itemParser = parseToCopyIconItem(allItemsHasIcon);
  const items = props.items?.map(itemParser);

  const data: CopyIconProps = { title, uid, items, hide_title: props.hide_title };

  if (data.items.length <= 3) {
    // eslint-disable-next-line no-console
    console.error('CopyWithIcons error: items count should be at least 3');
  }
  return <CopyIcon {...data} />;
};

export default CopyWithIcons;
